export const getPartnerAdminFormFieldValues = partnerDetails => {
  var _partnerDetails$admin, _partnerDetails$admin2, _partnerDetails$admin3, _partnerDetails$admin4, _partnerDetails$admin5, _partnerDetails$admin6, _partnerDetails$cloud, _partnerDetails$cloud2, _partnerDetails$cloud3, _partnerDetails$cloud4, _partnerDetails$cloud5, _partnerDetails$cloud6, _partnerDetails$admin7, _partnerDetails$admin8, _partnerDetails$partn, _partnerDetails$partn2;

  return {
    supportBaseUrl: (_partnerDetails$admin = (_partnerDetails$admin2 = partnerDetails.admin) === null || _partnerDetails$admin2 === void 0 ? void 0 : (_partnerDetails$admin3 = _partnerDetails$admin2.supportToolsDetails) === null || _partnerDetails$admin3 === void 0 ? void 0 : _partnerDetails$admin3.baseUri) !== null && _partnerDetails$admin !== void 0 ? _partnerDetails$admin : '',
    hasSolutionPartnerBenefit: (_partnerDetails$admin4 = (_partnerDetails$admin5 = partnerDetails.admin) === null || _partnerDetails$admin5 === void 0 ? void 0 : (_partnerDetails$admin6 = _partnerDetails$admin5.supportToolsDetails) === null || _partnerDetails$admin6 === void 0 ? void 0 : _partnerDetails$admin6.solutionPartnerBenefit) !== null && _partnerDetails$admin4 !== void 0 ? _partnerDetails$admin4 : false,
    isSecurityApproved: (_partnerDetails$cloud = (_partnerDetails$cloud2 = partnerDetails.cloudSecurity) === null || _partnerDetails$cloud2 === void 0 ? void 0 : _partnerDetails$cloud2.approved) !== null && _partnerDetails$cloud !== void 0 ? _partnerDetails$cloud : false,
    issueKey: (_partnerDetails$cloud3 = (_partnerDetails$cloud4 = partnerDetails.cloudSecurity) === null || _partnerDetails$cloud4 === void 0 ? void 0 : _partnerDetails$cloud4.issueKey) !== null && _partnerDetails$cloud3 !== void 0 ? _partnerDetails$cloud3 : '',
    securityExpiryDate: (_partnerDetails$cloud5 = (_partnerDetails$cloud6 = partnerDetails.cloudSecurity) === null || _partnerDetails$cloud6 === void 0 ? void 0 : _partnerDetails$cloud6.expiryDate) !== null && _partnerDetails$cloud5 !== void 0 ? _partnerDetails$cloud5 : '',
    canImportLicenses: (_partnerDetails$admin7 = (_partnerDetails$admin8 = partnerDetails.admin) === null || _partnerDetails$admin8 === void 0 ? void 0 : _partnerDetails$admin8.canImportLicenses) !== null && _partnerDetails$admin7 !== void 0 ? _partnerDetails$admin7 : false,
    marketplacePartnerTier: (_partnerDetails$partn = (_partnerDetails$partn2 = partnerDetails.partnerTier) === null || _partnerDetails$partn2 === void 0 ? void 0 : _partnerDetails$partn2.type) !== null && _partnerDetails$partn !== void 0 ? _partnerDetails$partn : ''
  };
};
export const getAdminUpdatePayload = ({
  supportBaseUrl,
  canImportLicenses,
  hasSolutionPartnerBenefit,
  isSecurityApproved,
  securityIssueKey = '',
  initialSecurityIssueKey,
  initialSupportBaseUrl,
  initialMarketplacePartnerTier,
  marketplacePartnerTier
}) => {
  let securityPayload = [];
  let supportDetailsPayload = [];
  let marketplacePartnerTierPayload = [];

  if (initialSupportBaseUrl !== '') {
    if (supportBaseUrl) {
      supportDetailsPayload = [{
        op: 'replace',
        path: '/admin/supportToolsDetails',
        value: {
          baseUri: supportBaseUrl,
          solutionPartnerBenefit: hasSolutionPartnerBenefit
        }
      }];
    } else {
      supportDetailsPayload = [{
        op: 'remove',
        path: '/admin/supportToolsDetails'
      }];
    }
  } else if (supportBaseUrl) {
    supportDetailsPayload = [{
      op: 'add',
      path: '/admin/supportToolsDetails',
      value: {
        baseUri: supportBaseUrl,
        solutionPartnerBenefit: hasSolutionPartnerBenefit
      }
    }];
  }

  if (initialMarketplacePartnerTier !== '' && initialMarketplacePartnerTier !== (marketplacePartnerTier === null || marketplacePartnerTier === void 0 ? void 0 : marketplacePartnerTier.value) && marketplacePartnerTier !== null && marketplacePartnerTier !== void 0 && marketplacePartnerTier.value) {
    marketplacePartnerTierPayload = [{
      op: 'replace',
      path: '/partnerTier/type',
      value: marketplacePartnerTier.value
    }];
  } else if (initialMarketplacePartnerTier === '' && marketplacePartnerTier !== null && marketplacePartnerTier !== void 0 && marketplacePartnerTier.value) {
    marketplacePartnerTierPayload = [{
      op: 'add',
      path: '/partnerTier/type',
      value: marketplacePartnerTier.value
    }];
  }

  if (!(initialSecurityIssueKey === securityIssueKey)) {
    if (isSecurityApproved) {
      const operation = initialSecurityIssueKey === '' ? 'add' : 'replace';
      securityPayload = [{
        op: operation,
        path: '/cloudSecurity',
        value: {
          approved: true,
          issueKey: securityIssueKey
        }
      }];
    } else {
      securityPayload = [{
        op: 'replace',
        path: '/cloudSecurity/approved',
        value: isSecurityApproved
      }];
    }
  }

  return [{
    op: 'replace',
    path: '/admin/canImportLicenses',
    value: canImportLicenses
  }, ...supportDetailsPayload, ...securityPayload, ...marketplacePartnerTierPayload];
};